import { GetServerSideProps } from 'next';
import { Noto_Sans_SC } from 'next/font/google';

export const notosans = Noto_Sans_SC({ subsets: ['latin'] });

const Index = () => {
  return (
    <div className="w-full h-full flex justify-center">
      <div className="w-[600px] py-[200px] overflow-auto">
        <h1 className="text-[48px] font-[500] leading-[56px]">
          FalcoCut Membership Service Agreement
        </h1>
        <p className="text-[15px] leading-[24px] py-[12px]">
          Welcome to FalcoCut membership service!
        </p>
        <p className="text-[15px] leading-[24px] py-[12px]">
          To use FalcoCut membership services, please carefully read, understand, and
          comply with the FalcoCut Membership Service Agreement (hereinafter referred to
          as &quot;this Agreement&quot;).
        </p>
        <p className="text-[15px] leading-[24px] py-[12px]">
          <b>
            This agreement is an agreement between you and Quvideo (Hong Kong) Limited
            (hereinafter referred to as &quot;we&quot; or &quot;the company&quot;, or
            &quot;the platform&quot;) on the use of FalcoCut membership services. It has
            the same legal effect on both parties. We remind you to carefully read all the
            contents of this agreement and focus on the clauses in bold that may have a
            significant relationship with your rights (including clauses related to our
            responsibilities, your rights, dispute resolution methods, and jurisdiction).
            If you believe that the bold terms in this agreement may result in partial or
            complete damage to your rights or interests, please reread the aforementioned
            terms before confirming your agreement to this agreement or before using this
            service, and use this service on the premise that you voluntarily accept such
            terms. Please read and understand all the terms carefully before agreeing to
            this agreement. You can keep a copy of the agreement by printing or saving
            this page for easy reference at any time.
          </b>
        </p>
        <p className="text-[15px] leading-[24px] py-[12px]">
          If you choose FalcoCut membership service, by accepting this service in the form
          of (including but not limited to clicking agree, accept or next, entering the
          purchase process, making any purchase of platform content, conducting or
          participating in any transaction or activity related to this service, using any
          other form of confirmation operation, hereinafter collectively referred to as
          &quot;accepting the service form&quot;), you indicate that you have read,
          understood and agreed to sign this agreement, indicating that you have reached
          an agreement relationship with us, and voluntarily accept and comply with all
          the provisions of this agreement. We have the right to change the content of
          this agreement. Once there is a change in the content of this agreement, we will
          notify you on the corresponding page, internal message or in other reasonable
          ways. Please read it carefully. You should regularly check the notifications we
          publish through web page announcements, internal messages, and other means. Any
          adverse consequences resulting from your failure to check notifications on time
          shall be borne by you. If you do not agree with the changes, you can choose to
          stop using the membership service. If you continue to use the membership
          service, it will be deemed that you have agreed to all the changes. The updated
          agreement shall come into effect from the date of the first update of the
          document. If you are a minor, please read and decide whether to agree to this
          agreement under the supervision and guidance of your guardian.
        </p>
        <h3 className="text-[36px] font-[500] leading-[44px] py-[32px]">
          I、 Membership services and service activation
        </h3>
        <p className="text-[15px] leading-[24px] py-[12px]">1.Membership Services</p>
        <p className="text-[15px] leading-[24px] py-[12px]">
          FalcoCut membership service means that users enjoy membership benefits and
          special services, including earning points and using materials, creating digital
          character images, and more. The specific content is subject to the description
          on the membership page. You understand and agree that we have the right to
          change, adjust, cancel, or add all or part of our membership benefits and
          special services based on product conditions, market conditions, and product
          updates and upgrades.
        </p>
        <p className="text-[15px] leading-[24px] py-[12px]">2.Service activation</p>
        <p className="text-[15px] leading-[24px] py-[12px]">
          Service activation includes a paid activation mode. Minors are not allowed to
          independently access paid membership services and must operate with the consent
          and guidance of their guardians. Guardians shall bear all responsibilities
          arising from the use of this service by minors.
        </p>
        <p className="text-[15px] leading-[24px] py-[12px]">2.1 Paid activation</p>
        <ul
          style={{ listStyle: 'lower-roman', paddingLeft: '35px', paddingBottom: '20px' }}
        >
          <li>
            This service is a paid service provided by us. You must pay the corresponding
            fees according to the charging standards and methods of this service before
            you can use it.{' '}
          </li>
          <li>
            You can complete the payment of member fees through the payment methods we
            actually support.
          </li>
          <li>
            We may modify and change the relevant rights and benefits, charging standards,
            methods, etc. of this service based on the overall planning of this service.
            The aforementioned modifications and changes will be displayed on the
            corresponding service page.
          </li>
          <li>
            Please be sure to understand the charging standards, methods, and other
            information related to this service before making a decision.
          </li>
          <li>
            You understand and agree that this service is a virtual product, and after
            payment or successful deduction, it does not support unsubscribing or
            refunding, except for situations where this service cannot be used normally
            after payment or where laws and regulations require otherwise. If a
            subscription refund occurs, the unused points in the corresponding package
            will immediately become invalid. If the service cannot be used normally due to
            platform reasons, users can apply for a refund from us, and the refund amount
            will be calculated based on the actual number of unused days.
          </li>
          <li>
            In the case of automatic renewal, it shall be deemed that you agree to deduct
            the service fee for the next billing cycle from your payment account
            (hereinafter referred to as the &quot;Account&quot;) balance when the FalcoCut
            membership service is about to expire. The billing cycle shall be based on the
            actual service period you have activated. Please ensure that the payment can
            be successfully deducted from the above account. The risk and/or loss of
            renewal failure due to your unbound account or insufficient deductible balance
            in the above account shall be borne by you. If you encounter any problems
            during the cancellation process, you can contact FalcoCut customer service.
            You acknowledge and agree that the deduction instructions you issued before
            cancelling the automatic renewal are still valid. We will not refund or pay
            any form of compensation for the fees deducted based on this instruction
            before the cancellation operation is completed. You shall bear the relevant
            responsibilities and losses on your own.
          </li>
        </ul>
        <p className="text-[36px] font-[500] leading-[44px] py-[32px]">
          2.2 Free activation
        </p>
        <ul
          style={{ listStyle: 'lower-roman', paddingLeft: '35px', paddingBottom: '20px' }}
        >
          <li>
            You may also be able to enjoy and use this service through other methods
            recognized by us, such as trials.{' '}
          </li>
          <li>
            When participating in our or our joint member gift activities with our
            partners, you should use the channels and methods officially
            announced/authorized by us and follow the activity rules to obtain the right
            to open and use. Otherwise, we have the right to cancel and/or refuse to
            provide FalcoCut member services, and all losses and liabilities incurred
            shall be borne by you.
          </li>
        </ul>
        <p className="text-[15px] leading-[24px] py-[12px]">
          2.3 Illegal or Illegal Opening{' '}
        </p>
        <p className="text-[15px] leading-[24px] py-[12px]">
          You are not allowed to activate this service for yourself or others through any
          of the following methods:
        </p>
        <ul
          style={{ listStyle: 'lower-roman', paddingLeft: '35px', paddingBottom: '20px' }}
        >
          <li>
            Use any robot software, spider software, crawler software, data brushing
            program or software to open this service for oneself or others;{' '}
          </li>
          <li>
            Open this service for oneself or others through any improper means or
            violation of the principle of good faith (such as exploiting loopholes in
            rules, exploiting system vulnerabilities, abusing membership status, black
            industry, speculation, etc.);
          </li>
          <li>
            Open this service for oneself or others through methods not specified by us;
          </li>
          <li>
            Opening up this service for oneself or others by infringing upon our or
            others&apos; legitimate rights and interests;
          </li>
          <li>Open this service for commercial or other non personal use purposes; </li>
          <li>
            Open this service for oneself or others through other means that violate laws,
            regulations, national policies, etc. Those who open this service for
            themselves or others in the above way are not protected. We have the right to
            cancel and/or refuse to provide FalcoCut membership services, and all losses
            and liabilities incurred shall be borne by you.
          </li>
        </ul>
        <p className="text-[15px] leading-[24px] py-[12px]">
          After you activate this service, there may be differences in the specific
          services you can use due to different versions, devices, operating systems, and
          other third-party reasons. You understand the inconvenience this may cause and
          we will not pursue or exempt you from any related responsibilities.
        </p>
        <h3 className="text-[36px] font-[500] leading-[44px] py-[32px]">
          II、 Service usage
        </h3>
        <p className="text-[15px] leading-[24px] py-[12px]">
          1. In the process of using FalcoCut membership services, you should comply with
          laws, regulations, and other normative documents, abide by public order, respect
          social morality, not endanger network security, not use the internet to engage
          in activities that endanger national security, honour, and interests, inciting
          subversion of state power, overthrow the socialist system, incite separatism,
          undermine national unity, promote terrorism and extremism, promote ethnic hatred
          and discrimination, spread violent, obscene and pornographic information,
          fabricate and spread false information to disrupt economic and social order and
          infringe on the reputation, privacy, intellectual property rights, and other
          legitimate rights and interests of others. If you engage in the above-mentioned
          behaviour, we have the right to terminate the provision of FalcoCut membership
          services to you.
        </p>
        <p className="text-[15px] leading-[24px] py-[12px]">
          2. During the use of FalcoCut membership services, you shall not have any
          adverse effects on the services provided by us, our affiliates, or third parties
          (including authorized parties and partners), or any activities related to these
          services, which may harm our and/or our affiliates&apos; or third parties&apos;
          interests. You shall not engage in any other behavior that may harm our
          legitimate interests.
        </p>
        <p className="text-[15px] leading-[24px] py-[12px]">
          3. This service is limited to your use on our official website. Any illegal
          means such as cracking, translating, transcribing, etc. that separate this
          service from us do not constitute FalcoCut membership services as stipulated in
          this agreement. We reserve the right to pursue legal responsibility and claim
          compensation from the infringer.
        </p>
        <p className="text-[15px] leading-[24px] py-[12px]">
          4. You understand and agree that you may not provide your account with this
          service in any way (including but not limited to transfer, rent, borrow, share,
          license, sell) to others for any use. Otherwise, any legal consequences and
          liabilities arising from this shall be borne by you, and we have the right to
          suspend or terminate the membership services of Xiaoying that you enjoy.
        </p>
        <p className="text-[15px] leading-[24px] py-[12px]">
          5. Unless otherwise agreed by both parties, we grant you a non exclusive,
          revocable, and fixed-term license to use FalcoCut membership services.
        </p>
        <p className="text-[15px] leading-[24px] py-[12px]">
          6. You understand, acknowledge, and agree that reasonable time required for
          troubleshooting, server maintenance, adjustment, upgrade, third-party
          infringement handling, etc. in this service will not be compensated separately.
        </p>
        <p className="text-[15px] leading-[24px] py-[12px]">
          7. You fully understand and agree that you are responsible for all actions under
          your account, including but not limited to any content you create, store,
          publish, or disseminate, as well as any consequences arising therefrom. You
          should make your own judgment on this service and the content you intend to use,
          and bear all risks arising therefrom.
        </p>
        <h3 className="text-[36px] font-[500] leading-[44px] py-[32px]">
          III、 Suspension and termination of services
        </h3>
        <p className="text-[15px] leading-[24px] py-[12px]">
          1.This service is suspended or terminated in the following situations:
        </p>
        <ul
          style={{ listStyle: 'lower-roman', paddingLeft: '35px', paddingBottom: '20px' }}
        >
          <li>
            User initiated suspension or termination, including but not limited to non
            renewal upon expiration, account cancellation;
          </li>
          <li>User cancels the Honor device account bound to this product;</li>
          <li>We suspend or terminate this service due to user breach of contract;</li>
          <li>
            In the event of national or relevant department requirements or force majeure
            events, we suspend or terminate this service;
          </li>
          <li>
            Other circumstances that require suspension or termination of this service
            occur.
          </li>
        </ul>
        <p className="text-[15px] leading-[24px] py-[12px]">
          2. Unless otherwise provided by law or stated in this agreement, we shall not be
          liable for the suspension or termination of this service, and any fees already
          collected shall not be refunded; We have no obligation to ensure that you
          receive notifications. If you find that you are unable to use this service, you
          can consult Xiaoying customer service.
        </p>
        <p className="text-[15px] leading-[24px] py-[12px]">
          3. You agree that due to the particularity of Internet services, we have the
          right to modify, change, interrupt, suspend or terminate some or all of the
          services, or change, delete, transfer your stored and published content for
          reasonable reasons, and you agree. We shall not be liable to you or any third
          party for any losses caused by the aforementioned actions. You agree that the
          services provided under any provision of this agreement may be changed,
          suspended or terminated without prior notice.
        </p>
        <h3 className="text-[36px] font-[500] leading-[44px] py-[32px]">
          IV、 Liability for breach of contract
        </h3>
        <p className="text-[15px] leading-[24px] py-[12px]">
          1. When using FalcoCut membership services, you must not engage in the following
          behaviors:
        </p>
        <ul
          style={{ listStyle: 'lower-roman', paddingLeft: '35px', paddingBottom: '20px' }}
        >
          <li>
            Modify service content, service period, consumption amount, transaction status
            and other information through technical means without our explicit
            authorization;
          </li>
          <li>
            Provide FalcoCut membership services to others for use through non authorized
            means (including but not limited to borrowing, renting, selling, sharing,
            transferring);
          </li>
          <li>
            Without our explicit authorization, copying, downloading, uploading,
            modifying, cataloging, sorting, translating, distributing, developing,
            transferring, selling, displaying, disseminating, synthesizing, nesting,
            linking, creating derivative works, conducting commercial development or
            promotion of all or part of the digital character images, materials, etc.
            provided by member services;
          </li>
          <li>
            Crack, modify, counter operate, tamper with, or otherwise disrupt any security
            measures or technologies we use to protect our member services;
          </li>
          <li>
            Other behaviors that violate our explicit authorization or violate this
            agreement, laws, regulations, or regulatory policies, or infringe upon the
            legitimate rights and interests of third parties or us.
          </li>
        </ul>
        <p className="text-[15px] leading-[24px] py-[12px]">
          You acknowledge and agree that if you engage in any behavior that violates
          national laws, regulations, or regulatory policies, violates this agreement, or
          damages the reputation and interests of us and/or our affiliates, we have the
          right to take one or more of the following measures:
        </p>
        <ul
          style={{ listStyle: 'lower-roman', paddingLeft: '35px', paddingBottom: '20px' }}
        >
          <li>
            If there is a separate clause in this agreement regarding the handling of this
            behavior, it shall be handled in accordance with that clause;
          </li>
          <li>
            Take one or more measures to stop your behavior and the consequences of your
            behavior, such as deleting/blocking relevant links or content,
            restricting/canceling your account/account usage permissions, etc;
          </li>
          <li>
            Interrupt or terminate part or all of the membership services, and the
            membership service fees you have already paid will not be refunded and you
            will not receive any form of compensation/indemnification;
          </li>
          <li>
            If your actions cause us and/or our affiliated companies to suffer any losses,
            you shall bear full liability for compensation and complete the payment of
            fees within the time limit required by us;{' '}
          </li>
          <li>
            If your breach of contract causes us and/or its affiliated companies to suffer
            losses, including but not limited to direct economic losses, goodwill losses,
            and external compensation, settlement payments, legal fees, litigation costs,
            preservation insurance premiums, etc., you shall compensate for all of the
            above losses.
          </li>
          <li>
            If your breach of contract causes any third-party damage, you shall be solely
            responsible. If we suffer losses as a result, you shall compensate us
            together.
          </li>
        </ul>
        <h3 className="text-[36px] font-[500] leading-[44px] py-[32px]">
          V、 Your personal information protection
        </h3>
        <p className="text-[15px] leading-[24px] py-[12px]">
          We are well aware of the importance of personal information to you, so we attach
          great importance to protecting your personal information and treating and
          processing it with a high degree of prudence. During your use of FalcoCut
          membership services, we will adopt relevant technical measures and other
          security measures to protect your personal information. For more information on
          personal information processing and protection rules, user control over personal
          information, etc., please refer to the full text of the Privacy Policy.
        </p>
        <h3 className="text-[36px] font-[500] leading-[44px] py-[32px]">
          VI、 Application of Law and Dispute Resolution
        </h3>
        <p className="text-[15px] leading-[24px] py-[12px]">
          The effectiveness, performance, interpretation, and dispute resolution of this
          agreement shall be governed by the laws of Hong Kong. In case of any dispute
          arising from the signing or performance of this agreement, both parties shall
          try their best to resolve it through friendly negotiation; If the negotiation
          fails, either party may bring a lawsuit to the people&apos;s court with
          jurisdiction over our domicile.
        </p>
        <h3 className="text-[36px] font-[500] leading-[44px] py-[32px]">VII、 Notice</h3>
        <p className="text-[15px] leading-[24px] py-[12px]">
          For you to know the information related to this agreement and the FalcoCut
          membership service, you agree that we have the right to notify you through one
          or more ways, including but not limited to website publicity, page prompts,
          pop-up windows, message notifications, official account notifications, and
          website letters. The notification is deemed to have been successfully delivered
          to you when we send it. If multiple notification methods coexist, the delivery
          time shall be based on the earliest of the above-mentioned methods. The content
          of such notifications may have a significant positive or negative impact on you.
          Please ensure that your contact information is valid and keep an eye on the
          corresponding notifications on time.
        </p>
        <h3 className="text-[36px] font-[500] leading-[44px] py-[32px]">
          VIII、 Contact Us
        </h3>
        <p className="text-[15px] leading-[24px] py-[12px]">
          If you have any questions about this agreement or the use of FalcoCut membership
          services, you can contact us through the following methods:
          Email:【team@falcocut.ai】 We will reply to you via email within 5 working days
          after receiving your feedback.
        </p>
        <p className="text-[15px] leading-[24px] py-[12px]"> (End of text)</p>
      </div>
    </div>
  );
};

export default Index;

export const getServerSideProps: GetServerSideProps = async (context) => {
  let returnData = {
    props: {},
  };

  return returnData;
};
